"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACSelectableCollection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACSelectableCollection = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a, _b = props.template, template = _b === void 0 ? null : _b, renderFields = props.renderFields, _c = props.variants, variants = _c === void 0 ? {} : _c, _d = props.variantKey, variantKey = _d === void 0 ? 'status' : _d, _e = props.disabledValues, disabledValues = _e === void 0 ? [] : _e, value = props.value, _f = props.itemKey, itemKey = _f === void 0 ? 'id' : _f, onSelect = props.onSelect;
    if (!Array.isArray(data) || !template) {
        return null;
    }
    var getVariantClasses = function (item, isSelected) {
        var _a, _b;
        var variantValue = item[variantKey];
        // Check if item is disabled based on disabledValues array
        var isDisabled = disabledValues.length > 0 && disabledValues.includes(variantValue);
        // Use the variant's own color regardless of disabled state
        var color = variants[variantValue] || 'gray';
        // Base classes
        var classes = 'rounded-lg border-2 cursor-pointer transition-all duration-200';
        // Disabled state
        if (isDisabled) {
            classes += ' opacity-50 !cursor-not-allowed';
        }
        // Color variants based on selection state
        var colorClasses = {
            green: {
                selected: 'bg-green-500 border-green-600 text-white shadow-lg scale-105',
                unselected: 'bg-green-50 border-green-500 text-green-600 hover:bg-green-100',
            },
            red: {
                selected: 'bg-red-500 border-red-600 text-white shadow-lg scale-105',
                unselected: 'bg-red-50 border-red-500 text-red-600 hover:bg-red-100',
            },
            yellow: {
                selected: 'bg-yellow-500 border-yellow-600 text-white shadow-lg scale-105',
                unselected: 'bg-yellow-50 border-yellow-500 text-yellow-600 hover:bg-yellow-100',
            },
            gray: {
                selected: 'bg-gray-500 border-gray-600 text-white shadow-lg scale-105',
                unselected: 'bg-gray-50 border-gray-500 text-gray-600 hover:bg-gray-100',
            },
            blue: {
                selected: 'bg-blue-500 border-blue-600 text-white shadow-lg scale-105',
                unselected: 'bg-blue-50 border-blue-500 text-blue-600 hover:bg-blue-100',
            },
            purple: {
                selected: 'bg-purple-500 border-purple-600 text-white shadow-lg scale-105',
                unselected: 'bg-purple-50 border-purple-500 text-purple-600 hover:bg-purple-100',
            },
        };
        var selectedClass = isSelected
            ? ((_a = colorClasses[color]) === null || _a === void 0 ? void 0 : _a.selected) || colorClasses.gray.selected
            : ((_b = colorClasses[color]) === null || _b === void 0 ? void 0 : _b.unselected) || colorClasses.gray.unselected;
        return "".concat(classes, " ").concat(selectedClass);
    };
    var handleCardClick = function (item) {
        var variantValue = item[variantKey];
        // Check if item is disabled
        var isDisabled = disabledValues.length > 0 && disabledValues.includes(variantValue);
        if (isDisabled) {
            return; // Don't allow selection of disabled items
        }
        // Toggle selection or change selection
        var newSelected = (value === null || value === void 0 ? void 0 : value[itemKey]) === (item === null || item === void 0 ? void 0 : item[itemKey]) ? null : item;
        // Call parent handler if provided
        if (onSelect) {
            onSelect(newSelected);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: props === null || props === void 0 ? void 0 : props.className, children: data.map(function (item, index) {
            var isSelected = (value === null || value === void 0 ? void 0 : value[itemKey]) === (item === null || item === void 0 ? void 0 : item[itemKey]);
            var variantClasses = getVariantClasses(item, isSelected);
            return ((0, jsx_runtime_1.jsx)("div", { className: variantClasses, onClick: function () { return handleCardClick(item); }, children: renderFields([__assign(__assign({}, template), { className: (template === null || template === void 0 ? void 0 : template.className) || '' })], item) }, index));
        }) }));
};
exports.ACSelectableCollection = ACSelectableCollection;
